// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TJsR","col":"styles_col__6vPH8"};